/**
 * @voltxampere/ui — PasteCommand (Sprint 13)
 *
 * Inject a clipboard fragment into a circuit. The constructor
 * regenerates ids and translates each component / wire by
 * `(pastePosition - fragment.bbox.center)` so the pasted cluster
 * lands under the cursor regardless of where it was copied from.
 *
 * Net references are remapped through the same id table so wires
 * still point at their components after the regen.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { regenerateIds } from "../clipboard.js";
export class PasteCommand {
    prepared;
    componentIds;
    wireIds;
    netIds;
    constructor(payload, pastePosition) {
        const fresh = regenerateIds(payload);
        const cx = fresh.bbox.x + fresh.bbox.w / 2;
        const cy = fresh.bbox.y + fresh.bbox.h / 2;
        const dx = pastePosition.x - cx;
        const dy = pastePosition.y - cy;
        const components = fresh.components.map((c) => ({
            ...c,
            position: { x: c.position.x + dx, y: c.position.y + dy },
        }));
        const wires = fresh.wires.map((w) => ({
            ...w,
            path: w.path.map((p) => ({ x: p.x + dx, y: p.y + dy })),
        }));
        this.prepared = { components, wires, nets: fresh.nets };
        this.componentIds = new Set(components.map((c) => c.id));
        this.wireIds = new Set(wires.map((w) => w.id));
        this.netIds = new Set(fresh.nets.map((n) => n.id));
    }
    do(circuit) {
        return {
            ...circuit,
            components: [...circuit.components, ...this.prepared.components],
            wires: [...circuit.wires, ...this.prepared.wires],
            nets: [...circuit.nets, ...this.prepared.nets],
        };
    }
    undo(circuit) {
        return {
            ...circuit,
            components: circuit.components.filter((c) => !this.componentIds.has(c.id)),
            wires: circuit.wires.filter((w) => !this.wireIds.has(w.id)),
            nets: circuit.nets.filter((n) => !this.netIds.has(n.id)),
        };
    }
    describe() {
        return `Yapıştırıldı (${String(this.prepared.components.length)} öge)`;
    }
}
//# sourceMappingURL=paste.js.map